
import { NavbarLogo } from "./navbar/NavbarLogo";
import { NavbarDesktop } from "./navbar/NavbarDesktop";
import { NavbarMobile } from "./navbar/NavbarMobile";

interface NavbarProps {
  variant?: "light" | "dark";
}

const Navbar = ({ variant = "light" }: NavbarProps) => {
  return (
    <header
      className="fixed top-0 left-0 w-full z-50 bg-white shadow-md py-2"
    >
      <div className="container mx-auto px-4 md:px-8">
        <div className="flex justify-between items-center">
          <NavbarLogo />
          <NavbarDesktop 
            textColorClass="text-drcash-maastricht-blue"
            hoverColorClass="hover:text-drcash-caribbean-green"
          />
          <NavbarMobile isScrolled={true} variant="light" />
        </div>
      </div>
    </header>
  );
};

export default Navbar;
